import { AgreementStatus } from "@debitroom-software/types";

import { useAuthorisationStore } from "@/modules/authorisation/authorisationStore";

export default async function checkPartnerAgreementStatus() {
  const authorisationStore = useAuthorisationStore();
  await authorisationStore.fetchProfileInformation();
  if (authorisationStore.hasErrorBecauseOfNoPartnerAccount) {
    return { name: "403" };
  }
  if (authorisationStore.agreements?.funderAgreementStatus !== AgreementStatus.Signed) {
    return { name: "funders.noAgreement" };
  }
  return undefined;
}
